import React from 'react';
import { makeStyles } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import { Tooltip } from 'components/Base';

const useStyles = makeStyles({
  wrapCashLabel: {
    userSelect: 'none',
    cursor: 'pointer',
    fontSize: '0.8125rem',
    display: 'flex',
    alignItems: 'center',
    position: 'relative'
  },
  dumbCheckbox: {
    position: 'relative',
    width: '20px',
    height: '20px',
    minWidth: '20px',
    borderRadius: '4px',
    border: '1px solid',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  text: {
    marginLeft: '0.8125rem',
    lineHeight: '1'
  },
  input: {
    position: 'absolute',
    visibility: 'hidden'
  },
  tooltipWrapper: {
    position: 'absolute',
    top: '-3px',
    left: 'calc(100% + 3px)'
  },
  icon: { color: '#fff', fontSize: '1rem', fontWeight: 'bold' }
});
interface WrapCashProps {
  toggleWrapCash: () => void;
  wrapChecked: boolean;
  tooltip?: any;
}

const WrapCash = ({ toggleWrapCash, wrapChecked, tooltip }: WrapCashProps) => {
  const classes = useStyles();
  return (
    <label className={classes.wrapCashLabel}>
      {tooltip && (
        <span className={classes.tooltipWrapper}>
          <Tooltip text={tooltip} />
        </span>
      )}
      <div
        className={classes.dumbCheckbox}
        style={{
          backgroundColor: wrapChecked ? '#656565' : '#fff',
          borderColor: wrapChecked ? 'none' : '#656565'
        }}
      >
        {wrapChecked && <DoneIcon className={classes.icon} />}
        <input
          className={classes.input}
          type="checkbox"
          onChange={toggleWrapCash}
          checked={wrapChecked}
        />
      </div>
      <span className={classes.text}>Wrap cash</span>
    </label>
  );
};

export default WrapCash;
